import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import './App.scss';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import EmailVerificationPage from './pages/EmailVerificationPage';
import ProvidePhonePage from './pages/ProvidePhonePage';
import { AppProvider } from './contexts/AppContext';
import RegisterPage from './pages/register/RegisterPage';
import { RegisterProvider } from './pages/register/RegisterContext';
import PhoneVerificationPage from './pages/phone-verification/PhoneVerificationPage';
import { CheckPhone } from './pages/password-recovery/CheckPhone';
import { PasswordRecovery } from './pages/password-recovery/PasswordRecovery';
import { RecoverySuccess } from './pages/password-recovery/RecoverySuccess';
import HomeAuth from './pages/home-auth/HomeAuthPage';


import MainApp from './components/MainApp';
import { AuthHandler, AuthProvider, ProtectedRoute } from 'orinabiji-auth-react';
import RegisterSuccessPage from './pages/register/RegisterSuccessPage';

function App(props: any) {
  const {
    REACT_APP_CAS_API_ISSUER,
    REACT_APP_CALLBACK_URL,
    REACT_APP_LOGOUR_REDIRECT_URL,
  } = process.env as Record<string, string>;

  return (
    <AuthProvider
      navigate={useNavigate()}
      issuer={REACT_APP_CAS_API_ISSUER}
      clientId="cas"
      redirectUrl={REACT_APP_CALLBACK_URL}
      audience="cas"
      logoutRedirectUrl={REACT_APP_LOGOUR_REDIRECT_URL}
      scope="openid profile scope"
    >
      <AppProvider>
        <MainApp>
          <Routes>
            <Route path="/register"
              element={
                <RegisterProvider>
                  <RegisterPage />
                </RegisterProvider>
              }
            />
            <Route path="/authHandler" element={<AuthHandler />} />
            <Route path="/verify/email" element={<EmailVerificationPage />} />
            <Route path="/check-phone" element={<CheckPhone />} />
            <Route
              path="/password-recovery/:userId"
              element={<PasswordRecovery />}
            />
            <Route path="/recovery-success" element={<RecoverySuccess />} />
            <Route
              path="/verify/contact/:userId"
              element={<PhoneVerificationPage />}
            />
            <Route path="/phone/:userId" element={<ProvidePhonePage />} />
            <Route path="*" element={<ProtectedRoute component={<HomeAuth />} />} />
            <Route path="/registerSuccess/:userId"
              element={<RegisterSuccessPage />}
            />
          </Routes>
        </MainApp>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
